export enum CustomerDynamicFilterType {
  TaskType = 'taskType',
  BillingAccount = 'billingAccount',
  DeliveryAccount = 'deliveryAccount',
  CreationDateFrom = 'creationDateFrom',
  ErpOrderNumber = 'erpOrderNumber',
  DocumentType = 'documentType',
  DocumentName = 'documentName',
}
